import { cacheDom } from "../utils/QuerySelectors.js"
import { toggleModal } from "../components/Popup.js"

const dom = {}
const qs = {
  section: 'data-footer',
  countrySelect: 'data-country-select',
}
const qsAll = {
  buttons: 'data-footer-trigger',
}

export const setupFooter = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    if(dom.countrySelect) {
      dom.countrySelect.addEventListener('click', () => {
        toggleModal(true, document.querySelector('#country-selector-popup').innerHTML, null, true, true)
      }) 
    }
    dom.buttons.forEach(button => {
      button.addEventListener('click', () => button.classList.toggle('footer-trigger--active'))
    })
  }
}